import type {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import type {EventsHomeReduxState} from '@Components/mystuff-events-home/mystuff-events-home.types';
import {getEventsScheduleInfoForUser} from '@Components/mystuff-events-home/mystuff-events-home-thunk';
import {LoadingStates} from '@Utils/loading.util';
import {mapUserEventsScheduleVOToFormState} from "@Components/mystuff-events-home/mystuff-events-home-slice";

export const mystuffEventsHomeExtraReducers = (builder: ActionReducerMapBuilder<EventsHomeReduxState>): void => {
  // A refresh keeps showing the calendar it already has; only the first load shows a loader.
  builder.addCase(getEventsScheduleInfoForUser.pending, (state) => {
    if (state.loadingState !== LoadingStates.LOADED) {
      state.loadingState = LoadingStates.LOADING;
    }
  });

  builder.addCase(getEventsScheduleInfoForUser.fulfilled, (state, {payload}) => {
    const userEventsScheduleVO = payload.userEventsSchedule;
    state.loadingState = LoadingStates.LOADED;
    if (!userEventsScheduleVO) {
      state.isEmptyState = true;
      return;
    }

    state.eventsHomeHashedId = userEventsScheduleVO.hashedID;
    mapUserEventsScheduleVOToFormState(state, userEventsScheduleVO);
    state.recentEmailsUsed = payload.emailSuggestions;
    state.recentPhoneNumbersUsed = payload.phoneNumberSuggestions;
    state.savedEventsScheduleVO = userEventsScheduleVO;
  });

  builder.addCase(getEventsScheduleInfoForUser.rejected, (state) => {
    state.loadingState = LoadingStates.LOADED;
  });
};
